import { render, staticRenderFns } from "./IbeRoom.vue?vue&type=template&id=3f920c4e"
import script from "./IbeRoom.vue?vue&type=script&lang=js"
export * from "./IbeRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports